import React, { useEffect } from 'react';
import seoGlobals from '../seo_globals.json';

interface SEOPageProps {
    title?: string;
    description?: string;
    image?: string;  // Custom OG image for detail pages
}

const ensurePropertyTag = (property: string, content: string) => {
    let tag = document.querySelector(`meta[property="${property}"]`);
    if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
    }
    tag.setAttribute('content', content);
};

const SEOPage: React.FC<SEOPageProps> = ({ title, description, image }) => {
    useEffect(() => {
        if (title) {
            document.title = title;
        }

        if (description) {
            const metaDescription = document.querySelector('meta[name="description"]');
            if (metaDescription) {
                metaDescription.setAttribute('content', description);
            }
        }

        // Update OG image - use custom image if provided, otherwise use default logo
        const ogImage = image || seoGlobals.seo.defaultOgImage;
        ensurePropertyTag('og:image', ogImage);
        ensurePropertyTag('twitter:image', ogImage);

        // Update OG title and description if provided
        if (title) {
            ensurePropertyTag('og:title', title);
            ensurePropertyTag('twitter:title', title);
        }
        if (description) {
            ensurePropertyTag('og:description', description);
            ensurePropertyTag('twitter:description', description);
        }
    }, [title, description, image]);

    return null;
};

export default SEOPage;
